var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exception"},[_c('card',{staticClass:"text-center"},[_c('div',{staticClass:"d-flex flex-column"},[_c('i',{staticClass:"fa fa-bug display-1"},[_vm._v("404")]),_c('p',[_vm._v(_vm._s(_vm.$t("errors.NotFound")))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }